import {Component, OnInit} from '@angular/core';
import {Waiter} from "../../shared/models/waiter";
import {WaiterService} from "../../core/http/waiter.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {OrderPosition} from "../../shared/models/OrderPosition";
import {WaiterShift} from "../../shared/models/waiter-shift";
import {AuthService} from "../../core/auth/auth.service";

@Component({
  selector: 'app-waiter-checkin-checkout',
  templateUrl: './waiter-checkin-checkout.component.html',
  styleUrls: ['./waiter-checkin-checkout.component.scss']
})
export class WaiterCheckinCheckoutComponent implements OnInit {
  selectedOption?: string;
  waiters: Waiter[] = [];
  waitersShift: WaiterShift[] = [];
  selectedWaiterShiftGuid?: string;
  selectedWaiterGuid?: string;

  userRoles: string[] | null = [];
  superAdmin = false;

  initialChange?: string;
  initialChangeCheckout: number = 0;
  revenueByManualCounting: number = 0;
  revenueBySystem: number = 0;
  calculatedTip: number = 0;
  tipKept: number = 0;
  tipDonated: number = 0;
  unprocessedCancelledPositions: number = 0;

  constructor(private waiterService: WaiterService, private _snackBar: MatSnackBar, private authService: AuthService) {
    this.userRoles = this.authService.getUserRole();
    this.superAdmin = this.userRoles && <boolean>this.userRoles!.includes('superadmin');
  }

  ngOnInit(): void {
    this.waiterService.getAllNotActiveShiftWaiters().subscribe({
      next: (response) => {
        this.waiters = response;
      },
      error: (error) => {
        console.log(error);
      }
    });

    this.waiterService.getAllActiveShiftWaiters().subscribe({
      next: (response) => {
        this.waitersShift = response;
        console.log(response);
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  onSelectedWaiterShift($event: any): void {
    const waiter = this.waitersShift.find((item => item.guid === $event));
    if (waiter && waiter.initialChange) this.initialChangeCheckout = waiter.initialChange;
    if (waiter && waiter.revenueBySystem) this.revenueBySystem = waiter.revenueBySystem;
    if (waiter && waiter.unprocessedCancelledPositions) this.unprocessedCancelledPositions = waiter.unprocessedCancelledPositions;
  }

  checkin(): void {
    if (this.initialChange && this.selectedWaiterGuid) {
      const numberString = this.initialChange.replace(/,/g, '.');
      if (this.isNumeric(numberString)) {
        const waiterShift: WaiterShift = {
          waiterGuid: this.selectedWaiterGuid,
          initialChange: parseFloat(this.initialChange)
        };
        this.waiterService.createWaiterShift(waiterShift).subscribe({
          next: (response) => {
            console.log(response);
            this.selectedWaiterGuid = '';
            this.initialChange = '';
            this._snackBar.open('Schicht erfolgreich angelegt. Login Code: ' + response.loginCode, 'Schließen');
            this.ngOnInit();
          },
          error: (error) => {
            console.log(error);
          }
        });
      } else {
        this._snackBar.open('Bitte Zahl eingeben', 'Schließen', {duration: 3000});
      }
    } else {
      this._snackBar.open('Bitte alle Daten eingeben', 'Schließen', {duration: 3000});
    }

  }

  checkout(): void {
    if (this.selectedWaiterGuid) {
        const waiterShift: WaiterShift = {
          guid: this.selectedWaiterGuid, // here it is the shift waiter guid
          revenueByManualCounting: this.revenueByManualCounting,
          tipKept: this.tipKept,
          tipDonated: this.tipDonated,
          revenueBySystem: this.revenueBySystem
        };
        this.waiterService.createWaiterShiftCheckout(waiterShift).subscribe({
          next: (response) => {
            console.log(response);
            this.selectedWaiterGuid = '';
            this.initialChangeCheckout = 0;
            this.revenueByManualCounting = 0;
            this.tipKept = 0;
            this.tipDonated = 0;
            this.calculatedTip = 0;
            this._snackBar.open('Kellner*in-Schicht erfolgreich abgeschlossen', 'Schließen', {duration: 3000});
            this.ngOnInit();
          },
          error: (error) => {
            console.log(error);
          }
        });
    } else {
      this._snackBar.open('Bitte alle Daten eingeben', 'Schließen', {duration: 3000});
    }
  }

  printWaiterReceipt(): void {
    if (this.selectedWaiterGuid) { // here it is the shift guid
      this.waiterService.printShiftWaiterReceipt(this.selectedWaiterGuid).subscribe({
        next: (response) => {
          console.log(response);
        },
        error: (error) => {
          console.error(error);
        }
      });
    } else {
      this._snackBar.open('Bitte Kellner auswählen', 'Schließen', {duration: 3000});
    }
  }

  calculateTip(): number {
    return this.revenueByManualCounting - this.initialChangeCheckout - this.revenueBySystem;
  }

  isNumeric(str: string): boolean {
    // Use the unary plus (+) operator to attempt parsing the string into a number
    return !isNaN(+str);
  }
}
